export class FilterSaverActionSet {
  static readonly type = '[FilterSaver] Define filters and pagination';
  constructor(public filterSaverPagination) {}
}

export class FilterSaverActionReset {
  static readonly type = '[FilterSaver] Clear current filter and pagination';
  
}